import { AppBar, Button, Toolbar } from "@mui/material"
import styles from "./Navbar.module.css"
import { useCallback, useEffect, useMemo, useState } from "react"
import { NavLink, useLocation, useNavigate } from "react-router-dom"
import Cookies from "js-cookie"


export default function Navbar() {
    const navigate = useNavigate()
    const location = useLocation()

    const [display, setDisplay] = useState<string>("none")
    const tokenChecker: string | undefined = process.env.REACT_APP_JWT

    useEffect(() => {
        const token: string | null = localStorage.getItem("token")
        if (location.pathname !== "/auth" && (!token || tokenChecker !== token)) {
            navigate('/auth')
        }
        if (location.pathname === "/auth") {
            setDisplay("none")
        } else {
            setDisplay("block")
        }
    }, [location.pathname])
    const navItems = useMemo(() => {
        return ([
            {
                path: "/",
                name: "LICENCE IMPAYE"
            },
            {
                path: "/search",
                name: "RECHERCHE"
            },            
            {
                path: "/settings",
                name: "SETTINGS"
            }
        ])
    }, [])

    const handleClick = useCallback((event: React.MouseEvent) => {
        event.preventDefault()
        localStorage.removeItem("token")
        navigate("/auth")
    }, [navigate])

    return (<>
        <AppBar position="static" sx={{
            display: `${display}`
        }}>
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "0 20px 0 0"
            }}>
                <Toolbar>
                    <div className={styles.navItemsContainer}>
                    {navItems.map((item, index) => (
                            <NavLink key={index} to={item.path} style={{
                                color: 'inherit',
                                textDecoration: 'none'
                            }}>{item.name}</NavLink>
                        ))}
                        </div>
                </Toolbar>
                <Button onClick={handleClick} sx={{
                    color: "#FFFFFF"
                }}>Déconnexion</Button>
            </div>
        </AppBar>
    </>)
}